var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "186.31 -772.15 587.38 588.15",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.27-184q-123.3 0-209.63-86.33-86.33-86.34-86.33-209.67 0-111.54 72.16-193.77t178.98-98.38q2.29 0 4.5.23 2.2.23 5.2.69-18.23 28.23-28.53 59.31-10.31 31.07-10.31 63.92 0 101.67 70.16 171.83Q548.64-406 650.31-406q32.07 0 63.54-10.31 31.46-10.31 58.92-28.54.46 3 .69 5.21t.23 4.49q-15.38 106.83-97.65 178.99T482.27-184m.04-32q82 0 148.77-47.07 66.78-47.08 98.23-122.93-20 5-39.67 8.5t-39.33 3.5q-113.86 0-193.93-80.07T376.31-648q0-19.67 3.5-39.33 3.5-19.67 8.5-39.67-75.86 31.45-122.93 98.22Q218.31-562 218.31-480q0 110 77 187t187 77m-14-250"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark_mode.7234c0d7a81086a5b097e6c852126f64.svg";
export { ForwardRef as ReactComponent };